module.exports = __webpack_public_path__ + "img/section7-3.3d7bd676.svg";